import { render, staticRenderFns } from "./Landlords.vue?vue&type=template&id=09666a66&scoped=true&"
import script from "./Landlords.vue?vue&type=script&lang=ts&"
export * from "./Landlords.vue?vue&type=script&lang=ts&"
import style0 from "./Landlords.vue?vue&type=style&index=0&id=09666a66&prod&scoped=true&lang=css&"
import style1 from "./Landlords.vue?vue&type=style&index=1&id=09666a66&prod&scoped=true&lang=css&"
import style2 from "./Landlords.vue?vue&type=style&index=2&id=09666a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09666a66",
  null
  
)

export default component.exports